import AuthService from '@/AuthService'
import { createRouter, createWebHistory } from 'vue-router'
 
 
const OverView = () => import('@/views/OverView.vue')
const DataTable = () => import(/* webpackChunkName: "gces" */ '@/views/DataTable.vue')
const GCESList = () => import(/* webpackChunkName: "gces" */ '@/crud/GCESList.vue')
const GCESEdit = () => import(/* webpackChunkName: "gces" */ '@/crud/GCESEdit.vue')
// const GCESSchemaList = () => import(/* webpackChunkName: "gces" */ '@/crud/GCESSchema/GCESSchemaList.vue')
// const GCESSchemaEdit = () => import(/* webpackChunkName: "gces" */ '@/crud/GCESSchema/GCESSchemaEdit.vue')
const TabAttrib = () => import(/* webpackChunkName: "gces" */ '@/components/gces/TabAttribution.vue')
const TdsMag = () => import(/* webpackChunkName: "gces" */ '@/components/gces/TdsMag.vue')
const OsmMag = () => import(/* webpackChunkName: "gces" */ '@/components/gces/OsmMag.vue');
const test = () => import('@/views/test.vue')
const ComingSoon = () => import('@/components/ComingSoon.vue')
const Downloads = () => import('@/components/Downloads.vue')
const ContactUs = () => import('@/components/ContactUs.vue');
const DataDetail = () => import(/* webpackChunkName: "gces" */ '@/views/DataDetail.vue')
const GCESPDF = () => import(/* webpackChunkName: "gces" */ '@/components/gces/GCESPDF.vue');
const NotFound = () => import('@/components/NotFound.vue')
const DPSLayout = () => import(/* webpackChunkName: "gces" */ '@/views/DPSLayout.vue')
const DPSContent = () => import(/* webpackChunkName: "gces" */ '@/views/DPSContent.vue')
const DPSHome = () => import('@/views/DPSHome.vue')
const DPSOverview = () => import('@/components/DPSOverview.vue')
const DPSTpcOncBodyText = () =>
  import(/* webpackChunkName: "tpconcBT" */ '@/components/tpconc/DPSTpcOncBodyText.vue');
const DPSTpcOncBodyTextForward = () =>
  import(/* webpackChunkName: "tpconcBT" */ '@/components/tpconc/DPSTpcOncBodyTextF.vue');
const DPSTpcOncBodyText1 = () => import(/* webpackChunkName: "tpconcBT" */ '@/components/tpconc/DPSTpcOncBodyText1.vue')
const DPSTpcOncBodyText2 = () => import(/* webpackChunkName: "tpconcBT" */ '@/components/tpconc/DPSTpcOncBodyText2.vue')
const DPSTpcOncBodyText3 = () => import(/* webpackChunkName: "tpconcBT" */ '@/components/tpconc/DPSTpcOncBodyText3.vue')
const DPSTpcOncBodyText4 = () => import(/* webpackChunkName: "tpconcBT" */ '@/components/tpconc/DPSTpcOncBodyText4.vue')
const DPSTpcOncBodyText5 = () => import(/* webpackChunkName: "tpconcBT" */ '@/components/tpconc/DPSTpcOncBodyText5.vue')
const DPSTpcOncBodyText6 = () => import(/* webpackChunkName: "tpconcBT" */ '@/components/tpconc/DPSTpcOncBodyText6.vue')
const DPSTpcOncBodyText7 = () => import(/* webpackChunkName: "tpconcBT" */ '@/components/tpconc/DPSTpcOncBodyText7.vue')
const DPSTpcOncBodyText8 = () => import(/* webpackChunkName: "tpconcBT" */ '@/components/tpconc/DPSTpcOncBodyText8.vue')
const DPSTpcOncBodyText9 = () => import(/* webpackChunkName: "tpconcBT" */ '@/components/tpconc/DPSTpcOncBodyText9.vue')
const DPSTpcOncBodyText10 = () => import(/* webpackChunkName: "tpconcBT" */'@/components/tpconc/DPSTpcOncBodyText10.vue')
const DPSTpcOncBodyText11 = () => import(/* webpackChunkName: "tpconcBT" */'@/components/tpconc/DPSTpcOncBodyText11.vue')
const DPSTpcOncBodyText12 = () => import(/* webpackChunkName: "tpconcBT" */'@/components/tpconc/DPSTpcOncBodyText12.vue')
const DPSTMBodyTextForward = () => import(/* webpackChunkName: "tmBT" */ '@/components/tm/DPSTmBodyTextF.vue')
const DPSTMBodyText1 = () => import(/* webpackChunkName: "tmBT" */ '@/components/tm/DPSTmBodyText1.vue')
const DPSTMBodyText2 = () => import(/* webpackChunkName: "tmBT" */ '@/components/tm/DPSTmBodyText2.vue')
const DPSTMBodyText3 = () => import(/* webpackChunkName: "tmBT" */ '@/components/tm/DPSTmBodyText3.vue')
const DPSTMBodyText4 = () => import(/* webpackChunkName: "tmBT" */ '@/components/tm/DPSTmBodyText4.vue')
const DPSTMBodyText5 = () => import(/* webpackChunkName: "tmBT" */ '@/components/tm/DPSTmBodyText5.vue')
const DPSTMBodyText6 = () => import(/* webpackChunkName: "tmBT" */ '@/components/tm/DPSTmBodyText6.vue')
const DPSTMBodyText7 = () => import(/* webpackChunkName: "tmBT" */ '@/components/tm/DPSTmBodyText7.vue')
const DPSTMBodyText8 = () => import(/* webpackChunkName: "tmBT" */ '@/components/tm/DPSTmBodyText8.vue')
const DPSTMBodyText9 = () => import(/* webpackChunkName: "tmBT" */ '@/components/tm/DPSTmBodyText9.vue')
const DPSTMBodyText10 = () => import(/* webpackChunkName: "tmBT" */ '@/components/tm/DPSTmBodyText10.vue')
const DPSTMBodyText11 = () => import(/* webpackChunkName: "tmBT" */ '@/components/tm/DPSTmBodyText11.vue')
const DPSTMBodyText12 = () => import(/* webpackChunkName: "tmBT" */ '@/components/tm/DPSTmBodyText12.vue')
const DPSJogBodyTextForward = () => import(/* webpackChunkName: "jogBT" */ '@/components/jog/DPSJogBodyTextF.vue')
const DPSJogBodyText1 = () => import(/* webpackChunkName: "jogBT" */ '@/components/jog/DPSJogBodyText1.vue')
const DPSJogBodyText2 = () => import(/* webpackChunkName: "jogBT" */ '@/components/jog/DPSJogBodyText2.vue')
const DPSJogBodyText3 = () => import(/* webpackChunkName: "jogBT" */ '@/components/jog/DPSJogBodyText3.vue')
const DPSJogBodyText4 = () => import(/* webpackChunkName: "jogBT" */ '@/components/jog/DPSJogBodyText4.vue')
const DPSJogBodyText5 = () => import(/* webpackChunkName: "jogBT" */ '@/components/jog/DPSJogBodyText5.vue')
const DPSJogBodyText6 = () => import(/* webpackChunkName: "jogBT" */ '@/components/jog/DPSJogBodyText6.vue')
const DPSJogBodyText7 = () => import(/* webpackChunkName: "jogBT" */ '@/components/jog/DPSJogBodyText7.vue')
const DPSJogBodyText8 = () => import(/* webpackChunkName: "jogBT" */ '@/components/jog/DPSJogBodyText8.vue')
const DPSJogBodyText9 = () => import(/* webpackChunkName: "jogBT" */ '@/components/jog/DPSJogBodyText9.vue')
const DPSJogBodyText10 = () => import(/* webpackChunkName: "jogBT" */ '@/components/jog/DPSJogBodyText10.vue')
const DPSJogBodyText11 = () => import(/* webpackChunkName: "jogBT" */ '@/components/jog/DPSJogBodyText11.vue')
const DPSJogBodyText12 = () => import(/* webpackChunkName: "jogBT" */ '@/components/jog/DPSJogBodyText12.vue')
const DPSEvcBodyTextForward = () => import(/* webpackChunkName: "evcBT" */ '@/components/evc/DPSEvcBodyTextF.vue')
const DPSEvcBodyTextPurpose = () => import(/* webpackChunkName: "evcBT" */ '@/components/evc/DPSEvcBodyTextPurpose.vue')
const DPSEvcBodyTextRef = () =>
  import(/* webpackChunkName: "evcBT" */ '@/components/evc/DPSEvcBodyTextRef.vue');
const DPSEvcBodyTextTerms = () =>
  import(/* webpackChunkName: "evcBT" */ '@/components/evc/DPSEvcBodyTextTerms.vue');
const DPSEvcBodyText1 = () => import(/* webpackChunkName: "evcBT" */ '@/components/evc/DPSEvcBodyText1.vue')
const DPSEvcBodyText2 = () => import(/* webpackChunkName: "evcBT" */ '@/components/evc/DPSEvcBodyText2.vue')
const DPSEvcBodyText3 = () => import(/* webpackChunkName: "evcBT" */ '@/components/evc/DPSEvcBodyText3.vue')
const DPSEvcBodyText4 = () => import(/* webpackChunkName: "evcBT" */ '@/components/evc/DPSEvcBodyText4.vue')
const DPSEvcBodyText5 = () => import(/* webpackChunkName: "evcBT" */ '@/components/evc/DPSEvcBodyText5.vue')
const DPSEvcBodyText6 = () => import(/* webpackChunkName: "evcBT" */ '@/components/evc/DPSEvcBodyText6.vue')
const DPSEvcBodyText7 = () => import(/* webpackChunkName: "evcBT" */ '@/components/evc/DPSEvcBodyText7.vue')
const DPSEvcBodyText8 = () => import(/* webpackChunkName: "evcBT" */ '@/components/evc/DPSEvcBodyText8.vue')
const DPSEvcBodyText9 = () => import(/* webpackChunkName: "evcBT" */ '@/components/evc/DPSEvcBodyText9.vue')
const DPSEvcBodyText10 = () => import(/* webpackChunkName: "evcBT" */ '@/components/evc/DPSEvcBodyText10.vue')
const DPSEvcBodyText11 = () => import(/* webpackChunkName: "evcBT" */ '@/components/evc/DPSEvcBodyText11.vue')
const DPSEvcBodyText12 = () => import(/* webpackChunkName: "evcBT" */ '@/components/evc/DPSEvcBodyText12.vue')
const DPSACF = () =>
  import(/* webpackChunkName: "tpconcAC" */ '@/components/tpconc/DPSTpcOncAnnoCatF.vue');
const DPSACC1 = () => import(/* webpackChunkName: "tpconcAC" */ '@/components/tpconc/DPSTpcOncAnnoCat1.vue')
const DPSACC2 = () => import(/* webpackChunkName: "tpconcAC" */ '@/components/tpconc/DPSTpcOncAnnoCat2.vue')
const DPSACC3 = () => import(/* webpackChunkName: "tpconcAC" */ '@/components/tpconc/DPSTpcOncAnnoCat3.vue')
const DPSACC4 = () => import(/* webpackChunkName: "tpconcAC" */ '@/components/tpconc/DPSTpcOncAnnoCat4.vue')
const DPSPCF = () => import( /* webpackChunkName: "tpconcPC" */ '@/components/tpconc/DPSTpcOncPortCatF.vue')
const DPSPCC1 = () => import(/* webpackChunkName: "tpconcPC" */ '@/components/tpconc/DPSTpcOncPortCat1.vue')
const DPSPCC2 = () => import(/* webpackChunkName: "tpconcPC" */ '@/components/tpconc/DPSTpcOncPortCat2.vue')
const DPSPCC3 = () => import(/* webpackChunkName: "tpconcPC" */ '@/components/tpconc/DPSTpcOncPortCat3.vue')
const DPSPCC4 = () => import(/* webpackChunkName: "tpconcPC" */ '@/components/tpconc/DPSTpcOncPortCat4.vue')
const DPSPdfGen = () => import('@/components/DPSPdfGen.vue')
const DPSDetail = () => import('@/views/DPSDetail.vue')
const DPSJogDetail = () => import(/* webpackChunkName: "jogAnnexA" */ '@/views/DPSJogDetail.vue')
const DPSEvcDetail = () => import(/* webpackChunkName: "evcAnnexA" */ '@/views/DPSEvcDetail.vue')
const DPSJogDetailOld = () => import(/* webpackChunkName: "jogAnnexA" */ '@/views/DPSJogDetailOld.vue')
const DPSTmDetail = () => import(/* webpackChunkName: "tmAnnexA" */ '@/views/DPSTmDetail.vue')
const DPSTpcDetail = () => import(/* webpackChunkName: "tpconcAnnexA" */ '@/views/DPSTpcDetail.vue')
const ProtectedResource = () => import('@/views/ProtectedResource.vue')
const Config = () => import('@/config.json')
const Jog = () => import(/* webpackChunkName: "jogAnnexA" */ '@/components/jog/DPSJog.vue')
const Evc = () => import(/* webpackChunkName: "evcAnnexA" */ '@/components/evc/DPSEvc.vue')
const JogOld = () => import(/* webpackChunkName: "jogAnnexA" */ '@/components/jog/DPSJogAnAOld.vue')
const Tm = () => import(/* webpackChunkName: "tmAnnexA" */ '@/components/tm/DPSTm.vue')
const TpcOnc = () =>
  import(/* webpackChunkName: "tpconcAnnexA" */ '@/components/tpconc/DPSTpcOnc.vue');
const TPCONCAnB = () => import(/* webpackChunkName: "tpconcAnnexes" */ '@/components/tpconc/DPSTpcOncAnB.vue')
const TPCONCAnC = () => import(/* webpackChunkName: "tpconcAnnexes" */ '@/components/tpconc/DPSTpcOncAnC.vue')
const TPCONCAnD = () => import(/* webpackChunkName: "tpconcAnnexes" */ '@/components/tpconc/DPSTpcOncAnD.vue')
const TPCONCAnE = () => import(/* webpackChunkName: "tpconcAnnexes" */ '@/components/tpconc/DPSTpcOncAnE.vue')
const TPCONCAnF = () => import(/* webpackChunkName: "tpconcAnnexes" */ '@/components/tpconc/DPSTpcOncAnF.vue')
const TPCONCAnG = () => import(/* webpackChunkName: "tpconcAnnexes" */ '@/components/tpconc/DPSTpcOncAnG.vue')
const TPCONCAnH = () => import(/* webpackChunkName: "tpconcAnnexes" */ '@/components/tpconc/DPSTpcOncAnH.vue')
const TPCONCAnI = () => import(/* webpackChunkName: "tpconcAnnexes" */ '@/components/tpconc/DPSTpcOncAnI.vue')
const TPCONCAnJ = () => import(/* webpackChunkName: "tpconcAnnexes" */ '@/components/tpconc/DPSTpcOncAnJ.vue')
const TPCONCAnHInfo = () => import(/* webpackChunkName: "tpconcAnnexes" */ '@/components/tpconc/DPSTpcOncAnHInfo.vue')
const TPCONCAnIInfo = () => import(/* webpackChunkName: "tpconcAnnexes" */ '@/components/tpconc/DPSTpcOncAnIInfo.vue')
const TPCONCAnJInfo = () => import(/* webpackChunkName: "tpconcAnnexes" */ '@/components/tpconc/DPSTpcOncAnJInfo.vue')
const TPCONCAnK = () => import(/* webpackChunkName: "tpconcAnnexes" */ '@/components/tpconc/DPSTpcOncAnK.vue')
const TPCONCAnL = () => import(/* webpackChunkName: "tpconcAnnexes" */ '@/components/tpconc/DPSTpcOncAnL.vue')
const TPCONCACAnA = () => import(/* webpackChunkName: "tpconcAnnexes" */ '@/components/tpconc/DPSTpcOncACAnA.vue')
const TPCONCACAnB = () => import(/* webpackChunkName: "tpconcAnnexes" */ '@/components/tpconc/DPSTpcOncACAnB.vue')
const TPCONCBTAnA1 = () => import(/* webpackChunkName: "tpconcAnnexes" */ '@/components/tpconc/DPSTpcOncBTAnA1.vue')
const TPCONCBTAnA2 = () => import(/* webpackChunkName: "tpconcAnnexes" */ '@/components/tpconc/DPSTpcOncBTAnA2.vue')
const TMPCF = () => import(/* webpackChunkName: "tmPC" */ '@/components/tm/DPSTmPortCatF.vue')
const TMPCC1 = () => import(/* webpackChunkName: "tmPC" */ '@/components/tm/DPSTmPortCat1.vue')
const TMPCC2 = () => import(/* webpackChunkName: "tmPC" */ '@/components/tm/DPSTmPortCat2.vue')
const TMPCC3 = () => import(/* webpackChunkName: "tmPC" */ '@/components/tm/DPSTmPortCat3.vue')
const TMPCC4 = () => import(/* webpackChunkName: "tmPC" */ '@/components/tm/DPSTmPortCat4.vue')
const TMAnB = () => import(/* webpackChunkName: "tmAnnexes" */ '@/components/tm/DPSTmAnB.vue')
const TMAnC = () => import(/* webpackChunkName: "tmAnnexes" */ '@/components/tm/DPSTmAnC.vue')
const TMAnD = () => import(/* webpackChunkName: "tmAnnexes" */ '@/components/tm/DPSTmAnD.vue')
const TMAnE = () => import(/* webpackChunkName: "tmAnnexes" */ '@/components/tm/DPSTmAnE.vue')
const TMAnF = () => import(/* webpackChunkName: "tmAnnexes" */ '@/components/tm/DPSTmAnF.vue')
const TMAnG = () => import(/* webpackChunkName: "tmAnnexes" */ '@/components/tm/DPSTmAnG.vue')
const TMAnH = () => import(/* webpackChunkName: "tmAnnexes" */ '@/components/tm/DPSTmAnH.vue')
const TMAnI = () => import(/* webpackChunkName: "tmAnnexes" */ '@/components/tm/DPSTmAnI.vue')
const TMAnJ = () => import(/* webpackChunkName: "tmAnnexes" */ '@/components/tm/DPSTmAnJ.vue')
const TMAnHInfo = () => import(/* webpackChunkName: "tmAnnexes" */ '@/components/tm/DPSTmAnHInfo.vue')
const TMAnIInfo = () => import(/* webpackChunkName: "tmAnnexes" */ '@/components/tm/DPSTmAnIInfo.vue')
const TMAnJInfo = () => import(/* webpackChunkName: "tmAnnexes" */ '@/components/tm/DPSTmAnJInfo.vue')
const TMAnK = () => import(/* webpackChunkName: "tmAnnexes" */ '@/components/tm/DPSTmAnK.vue')
const TMAnL = () => import(/* webpackChunkName: "tmAnnexes" */ '@/components/tm/DPSTmAnL.vue')
const TMACAnA = () => import(/* webpackChunkName: "tmAnnexes" */ '@/components/tm/DPSTmACAnA.vue')
const TMACAnADetail = () => import(/* webpackChunkName: "tmAnnexes" */ '@/components/tm/DPSTmACAnADetail.vue')
const TMACAnB = () => import(/* webpackChunkName: "tmAnnexes" */ '@/components/tm/DPSTmACAnB.vue')
const TMACF = () => import(/* webpackChunkName: "tmAC" */ '@/components/tm/DPSTmAnnoCatF.vue')
const TMACC1 = () => import(/* webpackChunkName: "tmAC" */ '@/components/tm/DPSTmAnnoCat1.vue')
const TMACC2 = () => import(/* webpackChunkName: "tmAC" */ '@/components/tm/DPSTmAnnoCat2.vue')
const TMACC3 = () => import(/* webpackChunkName: "tmAC" */ '@/components/tm/DPSTmAnnoCat3.vue')
const TMACC4 = () => import(/* webpackChunkName: "tmAC" */ '@/components/tm/DPSTmAnnoCat4.vue')
const TMBTAnA1 = () => import(/* webpackChunkName: "tmAnnexes" */ '@/components/tm/DPSTmBTAnA1.vue')
const TMBTAnA2 = () => import(/* webpackChunkName: "tmAnnexes" */ '@/components/tm/DPSTmBTAnA2.vue')
const JogPCF = () => import(/* webpackChunkName: "jogPC" */ '@/components/jog/DPSJogPortCatF.vue')
const JogPCC1 = () => import(/* webpackChunkName: "jogPC" */ '@/components/jog/DPSJogPortCat1.vue')
const JogPCC2 = () => import(/* webpackChunkName: "jogPC" */ '@/components/jog/DPSJogPortCat2.vue')
const JogPCC3 = () => import(/* webpackChunkName: "jogPC" */ '@/components/jog/DPSJogPortCat3.vue')
const JogPCC4 = () => import(/* webpackChunkName: "jogPC" */ '@/components/jog/DPSJogPortCat4.vue')
const JogAnB = () => import(/* webpackChunkName: "jogAnnexes" */ '@/components/jog/DPSJogAnB.vue')
const JogAnC = () => import(/* webpackChunkName: "jogAnnexes" */ '@/components/jog/DPSJogAnC.vue')
const JogAnD = () => import(/* webpackChunkName: "jogAnnexes" */ '@/components/jog/DPSJogAnD.vue')
const JogAnE = () => import(/* webpackChunkName: "jogAnnexes" */ '@/components/jog/DPSJogAnE.vue')
const JogAnF = () => import(/* webpackChunkName: "jogAnnexes" */ '@/components/jog/DPSJogAnF.vue')
const JogAnG = () => import(/* webpackChunkName: "jogAnnexes" */ '@/components/jog/DPSJogAnG.vue')
const JogAnH = () => import(/* webpackChunkName: "jogAnnexes" */ '@/components/jog/DPSJogAnH.vue')
const JogAnI = () => import(/* webpackChunkName: "jogAnnexes" */ '@/components/jog/DPSJogAnI.vue')
const JogAnJ = () => import(/* webpackChunkName: "jogAnnexes" */ '@/components/jog/DPSJogAnJ.vue')
const JogAnHInfo = () => import(/* webpackChunkName: "jogAnnexes" */ '@/components/jog/DPSJogAnHInfo.vue')
const JogAnIInfo = () => import(/* webpackChunkName: "jogAnnexes" */ '@/components/jog/DPSJogAnIInfo.vue')
const JogAnJInfo = () => import(/* webpackChunkName: "jogAnnexes" */ '@/components/jog/DPSJogAnJInfo.vue')
const JogAnK = () => import(/* webpackChunkName: "jogAnnexes" */ '@/components/jog/DPSJogAnK.vue')
const JogAnL = () => import(/* webpackChunkName: "jogAnnexes" */ '@/components/jog/DPSJogAnL.vue')
const JogAnM = () => import(/* webpackChunkName: "jogAnnexes" */ '@/components/jog/DPSJogAnM.vue')
const JogACAnA = () => import(/* webpackChunkName: "jogAnnexes" */ '@/components/jog/DPSJogACAnA.vue')
const JogACAnADetail = () => import(/* webpackChunkName: "jogAnnexes" */ '@/components/jog/DPSJogACAnADetail.vue')
const JogACAnB = () => import(/* webpackChunkName: "jogAnnexes" */ '@/components/jog/DPSJogACAnB.vue')
const JogACF = () => import(/* webpackChunkName: "jogAC" */ '@/components/jog/DPSJogAnnoCatF.vue')
const JogACC1 = () => import(/* webpackChunkName: "jogAC" */'@/components/jog/DPSJogAnnoCat1.vue')
const JogACC2 = () => import(/* webpackChunkName: "jogAC" */'@/components/jog/DPSJogAnnoCat2.vue')
const JogACC3 = () => import(/* webpackChunkName: "jogAC" */'@/components/jog/DPSJogAnnoCat3.vue')
const JogACC4 = () => import(/* webpackChunkName: "jogAC" */'@/components/jog/DPSJogAnnoCat4.vue')
const JogBTAnA1 = () => import(/* webpackChunkName: "jogAnnexes" */ '@/components/jog/DPSJogBTAnA1.vue')
const JogBTAnA2 = () => import(/* webpackChunkName: "jogAnnexes" */ '@/components/jog/DPSJogBTAnA2.vue')
const EvcPCC1 = () => import(/* webpackChunkName: "EvcPC" */ '@/components/evc/DPSEvcPortCat1.vue')
const EvcPCC2 = () => import(/* webpackChunkName: "EvcPC" */ '@/components/evc/DPSEvcPortCat2.vue')
const EvcPCC3 = () => import(/* webpackChunkName: "EvcPC" */ '@/components/evc/DPSEvcPortCat3.vue')
const EvcPCC4 = () => import(/* webpackChunkName: "EvcPC" */ '@/components/evc/DPSEvcPortCat4.vue')
const EvcPCC5 = () => import(/* webpackChunkName: "EvcPC" */ '@/components/evc/DPSEvcPortCat5.vue')
const EvcAnB = () => import(/* webpackChunkName: "EvcAnnexes" */ '@/components/evc/DPSEvcAnB.vue')
const EvcAnC = () => import(/* webpackChunkName: "EvcAnnexes" */ '@/components/evc/DPSEvcAnC.vue')
const EvcAnD = () => import(/* webpackChunkName: "EvcAnnexes" */ '@/components/evc/DPSEvcAnD.vue')
const EvcAnE = () => import(/* webpackChunkName: "EvcAnnexes" */ '@/components/evc/DPSEvcAnE.vue')
const EvcAnF = () => import(/* webpackChunkName: "EvcAnnexes" */ '@/components/evc/DPSEvcAnF.vue')
const EvcAnG = () => import(/* webpackChunkName: "EvcAnnexes" */ '@/components/evc/DPSEvcAnG.vue')
const EvcAnH = () => import(/* webpackChunkName: "EvcAnnexes" */ '@/components/evc/DPSEvcAnH.vue')
const EvcAnI = () => import(/* webpackChunkName: "EvcAnnexes" */ '@/components/evc/DPSEvcAnI.vue')
const EvcAnJ = () => import(/* webpackChunkName: "EvcAnnexes" */ '@/components/evc/DPSEvcAnJ.vue')
const EvcAnHInfo = () => import(/* webpackChunkName: "EvcAnnexes" */ '@/components/evc/DPSEvcAnHInfo.vue')
const EvcAnIInfo = () => import(/* webpackChunkName: "EvcAnnexes" */ '@/components/evc/DPSEvcAnIInfo.vue')
const EvcAnJInfo = () => import(/* webpackChunkName: "EvcAnnexes" */ '@/components/evc/DPSEvcAnJInfo.vue')
const EvcAnK = () => import(/* webpackChunkName: "EvcAnnexes" */ '@/components/evc/DPSEvcAnK.vue')
const EvcAnL = () => import(/* webpackChunkName: "EvcAnnexes" */ '@/components/evc/DPSEvcAnL.vue')
const EvcAnM = () => import(/* webpackChunkName: "EvcAnnexes" */ '@/components/evc/DPSEvcAnM.vue')
const EvcAnN = () => import(/* webpackChunkName: "EvcAnnexes" */ '@/components/evc/DPSEvcAnN.vue')
const EvcAnO = () => import(/* webpackChunkName: "EvcAnnexes" */ '@/components/evc/DPSEvcAnO.vue')
const EvcAnP = () => import(/* webpackChunkName: "EvcAnnexes" */ '@/components/evc/DPSEvcAnP.vue')
const EvcAnPT = () => import(/* webpackChunkName: "EvcAnnexestest" */ '@/components/evc/DPSEvcAnPText.vue')
const EvcAnP3 = () => import(/* webpackChunkName: "EvcAnnexes" */ '@/components/evc/DPSEvcAnP3.vue')
const EvcAnT = () => import(/* webpackChunkName: "EvcAnnexes" */ '@/components/evc/DPSEvcAnT.vue')
const EvcACC1 = () => import(/* webpackChunkName: "EvcAC" */'@/components/evc/DPSEvcAnnoCat1.vue')
const EvcACC2 = () => import(/* webpackChunkName: "EvcAC" */'@/components/evc/DPSEvcAnnoCat2.vue')
const EvcACC3 = () => import(/* webpackChunkName: "EvcAC" */'@/components/evc/DPSEvcAnnoCat3.vue')
const EvcBTAnB1 = () => import(/* webpackChunkName: "EvcAnnexes" */ '@/components/evc/DPSEvcBTAnB1.vue')
const EvcBTAnB2 = () => import(/* webpackChunkName: "EvcAnnexes" */ '@/components/evc/DPSEvcBTAnB2.vue')
 
const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      component: OverView,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - Overview',
      },
    },
    {
      path: '/content',
      component: DataTable,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - GCES',
      },
    },
    {
      path: '/gceslist',
      component: GCESList,
      meta: {
        requiresAuth: true,
        title: 'Foundation GEOINT Standards - GCES',
      },
    },
    {
      path: '/gceslist/:NAS_ID',
      name: 'gcesedit',
      component: GCESEdit,
      props: true,
      beforeEnter: (to, from, next) => {
        if (to.params.NAS_ID == null) {
          next('/404');
        } else {
          next();
        }
      },
      meta: {
        requiresAuth: true,
        title: 'Foundation GEOINT Standards - GCES',
      },
    },
    // {
    //   path: '/gcesschlist',
    //   component: GCESSchemaList,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/gcesschlist/:NAS_ID',
    //   name: 'gcesschedit',
    //   component: GCESSchemaEdit,
    //   props: true,
    //   beforeEnter: (to, from, next) => {
    //     if (to.params.NAS_ID == null) {
    //       next('/404');
    //     } else {
    //       next();
    //     }
    //   },
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    {
      path: '/gcespdf',
      component: GCESPDF,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - GCES PDF',
      },
    },
    {
      path: '/test',
      component: test,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/downloads',
      component: Downloads,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - Downloads',
      },
    },
    {
      path: '/contactus',
      component: ContactUs,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - Contact Us',
      },
    },
    {
      // path: "/topics/:NAS_ID/:Name",
      path: '/content/:NAS_ID',
      //****this below 'name' property critical for functional router links****
      name: 'datadetail',
      component: DataDetail,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - GCES',
      },
      props: true,
      // if NAS_ID does not exist, show 404 page
      //note: the 'to' parameter is alias for $route object!
      beforeEnter: (to, from, next) => {
        if (to.params.NAS_ID == null) {
          next('/404');
        } else {
          next();
        }
      },
    },
    {
      path: '/dps/:NAS_ID',
      name: 'dpsdetail',
      component: DPSDetail,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - GCES',
      },
      props: true,
      beforeEnter: (to, from, next) => {
        if (to.params.NAS_ID == null) {
          next('/404');
        } else {
          next();
        }
      },
    },
    {
      path: '/tds/:NAS_ID',
      name: 'tabattrib',
      component: TabAttrib,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - GCES',
      },
      props: true,
      beforeEnter: (to, from, next) => {
        if (to.params.NAS_ID == null) {
          next('/404');
        } else {
          next();
        }
      },
    },
    {
      path: '/tdsmag/:NAS_ID',
      name: 'tdsmag',
      component: TdsMag,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - GCES',
      },
      props: true,
      beforeEnter: (to, from, next) => {
        if (to.params.NAS_ID == null) {
          next('/404');
        } else {
          next();
        }
      },
    },
    {
      path: '/osmmag/:NAS_ID',
      name: 'osmmag',
      component: OsmMag,
      props: true,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - GCES',
      },
      beforeEnter: (to, from, next) => {
        if (to.params.NAS_ID == null) {
          next('/404');
        } else {
          next();
        }
      },
    },
    {
      path: '/dpsold',
      component: DPSContent,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS',
      },
    },
    {
      path: '/dpshome',
      component: DPSHome,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Home',
      },
    },
    {
      path: '/dps',
      component: DPSOverview,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Overview',
      },
    },
    {
      path: '/bt',
      component: DPSTpcOncBodyText,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/btf',
      component: DPSTpcOncBodyTextForward,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/bt1',
      component: DPSTpcOncBodyText1,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/bt2',
      component: DPSTpcOncBodyText2,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/bt3',
      component: DPSTpcOncBodyText3,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/bt4',
      component: DPSTpcOncBodyText4,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/bt5',
      component: DPSTpcOncBodyText5,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/bt6',
      component: DPSTpcOncBodyText6,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/bt7',
      component: DPSTpcOncBodyText7,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/bt8',
      component: DPSTpcOncBodyText8,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/bt9',
      component: DPSTpcOncBodyText9,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/bt10',
      component: DPSTpcOncBodyText10,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/bt11',
      component: DPSTpcOncBodyText11,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/bt12',
      component: DPSTpcOncBodyText12,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/acf',
      component: DPSACF,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/acc1',
      component: DPSACC1,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/acc2',
      component: DPSACC2,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/acc3',
      component: DPSACC3,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/acc4',
      component: DPSACC4,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/pcf',
      component: DPSPCF,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/pcc1',
      component: DPSPCC1,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/pcc2',
      component: DPSPCC2,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/pcc3',
      component: DPSPCC3,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/pcc4',
      component: DPSPCC4,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/pdf',
      component: DPSPdfGen,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/jog',
      component: Jog,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jog/:_ID',
      name: 'dpsjogdetail',
      component: DPSJogDetail,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
      props: true,
      beforeEnter: (to, from, next) => {
        if (to.params._ID == null) {
          next('/404');
        } else {
          next();
        }
      },
    },
    {
      path: '/evc',
      component: Evc,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evc/:_ID',
      name: 'dpsevcdetail',
      component: DPSEvcDetail,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
      props: true,
      beforeEnter: (to, from, next) => {
        if (to.params._ID == null) {
          next('/404');
        } else {
          next();
        }
      },
    },
    {
      path: '/jog_',
      component: JogOld,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/dps/jog_/:_ID',
      name: 'dpsjogdetailold',
      component: DPSJogDetailOld,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
      props: true,
      beforeEnter: (to, from, next) => {
        if (to.params._ID == null) {
          next('/404');
        } else {
          next();
        }
      },
    },
    {
      path: '/jogbtf',
      component: DPSJogBodyTextForward,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogbt1',
      component: DPSJogBodyText1,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogbt2',
      component: DPSJogBodyText2,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogbt3',
      component: DPSJogBodyText3,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogbt4',
      component: DPSJogBodyText4,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogbt5',
      component: DPSJogBodyText5,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogbt6',
      component: DPSJogBodyText6,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogbt7',
      component: DPSJogBodyText7,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogbt8',
      component: DPSJogBodyText8,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogbt9',
      component: DPSJogBodyText9,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogbt10',
      component: DPSJogBodyText10,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogbt11',
      component: DPSJogBodyText11,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogbt12',
      component: DPSJogBodyText12,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogpcf',
      component: JogPCF,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogpcc1',
      component: JogPCC1,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogpcc2',
      component: JogPCC2,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogpcc3',
      component: JogPCC3,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogpcc4',
      component: JogPCC4,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogacf',
      component: JogACF,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogacc1',
      component: JogACC1,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogacc2',
      component: JogACC2,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogacc3',
      component: JogACC3,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogacc4',
      component: JogACC4,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/joganb',
      component: JogAnB,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/joganc',
      component: JogAnC,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogand',
      component: JogAnD,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogane',
      component: JogAnE,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/joganf',
      component: JogAnF,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogang',
      component: JogAnG,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/joganh',
      component: JogAnH,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogani',
      component: JogAnI,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/joganj',
      component: JogAnJ,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/joganhinfo',
      component: JogAnHInfo,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/joganiinfo',
      component: JogAnIInfo,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/joganjinfo',
      component: JogAnJInfo,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogank',
      component: JogAnK,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/joganl',
      component: JogAnL,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/joganm',
      component: JogAnM,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogacana',
      component: JogACAnA,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/dps/jogacana/:_ID',
      name: 'dpsjogacadetail',
      component: JogACAnADetail,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG PC Annex A',
      },
      props: true,
      beforeEnter: (to, from, next) => {
        if (to.params._ID == null) {
          next('/404');
        } else {
          next();
        }
      },
    },
    {
      path: '/jogacanb',
      component: JogACAnB,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogbtana1',
      component: JogBTAnA1,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/jogbtana2',
      component: JogBTAnA2,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS JOG',
      },
    },
    {
      path: '/evcbtf',
      component: DPSEvcBodyTextForward,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcbtp',
      component: DPSEvcBodyTextPurpose,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcbtr',
      component: DPSEvcBodyTextRef,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcbtt',
      component: DPSEvcBodyTextTerms,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcbt1',
      component: DPSEvcBodyText1,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcbt2',
      component: DPSEvcBodyText2,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcbt3',
      component: DPSEvcBodyText3,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcbt4',
      component: DPSEvcBodyText4,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcbt5',
      component: DPSEvcBodyText5,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcbt6',
      component: DPSEvcBodyText6,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcbt7',
      component: DPSEvcBodyText7,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcbt8',
      component: DPSEvcBodyText8,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcbt9',
      component: DPSEvcBodyText9,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcbt10',
      component: DPSEvcBodyText10,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcbt11',
      component: DPSEvcBodyText11,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcbt12',
      component: DPSEvcBodyText12,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcpcc1',
      component: EvcPCC1,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcpcc2',
      component: EvcPCC2,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcpcc3',
      component: EvcPCC3,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcpcc4',
      component: EvcPCC4,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcpcc5',
      component: EvcPCC5,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcacc1',
      component: EvcACC1,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcacc2',
      component: EvcACC2,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcacc3',
      component: EvcACC3,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcanb',
      component: EvcAnB,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcanc',
      component: EvcAnC,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcand',
      component: EvcAnD,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcane',
      component: EvcAnE,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcanf',
      component: EvcAnF,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcang',
      component: EvcAnG,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcanh',
      component: EvcAnH,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcani',
      component: EvcAnI,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcanj',
      component: EvcAnJ,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcanhinfo',
      component: EvcAnHInfo,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcaniinfo',
      component: EvcAnIInfo,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcanjinfo',
      component: EvcAnJInfo,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcank',
      component: EvcAnK,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcanl',
      component: EvcAnL,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcanm',
      component: EvcAnM,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcann',
      component: EvcAnN,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcano',
      component: EvcAnO,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcanp',
      component: EvcAnP,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcanpt',
      component: EvcAnPT,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcanp3',
      component: EvcAnP3,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcant',
      component: EvcAnT,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcbtanb1',
      component: EvcBTAnB1,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },
    {
      path: '/evcbtanb2',
      component: EvcBTAnB2,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS Evc',
      },
    },

    {
      path: '/tm',
      component: Tm,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM PC Annex A',
      },
    },
    {
      path: '/tmbtf',
      component: DPSTMBodyTextForward,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmbt1',
      component: DPSTMBodyText1,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmbt2',
      component: DPSTMBodyText2,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmbt3',
      component: DPSTMBodyText3,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmbt4',
      component: DPSTMBodyText4,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmbt5',
      component: DPSTMBodyText5,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmbt6',
      component: DPSTMBodyText6,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmbt7',
      component: DPSTMBodyText7,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmbt8',
      component: DPSTMBodyText8,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmbt9',
      component: DPSTMBodyText9,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmbt10',
      component: DPSTMBodyText10,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmbt11',
      component: DPSTMBodyText11,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmbt12',
      component: DPSTMBodyText12,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmpcf',
      component: TMPCF,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmpcc1',
      component: TMPCC1,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmpcc2',
      component: TMPCC2,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmpcc3',
      component: TMPCC3,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmpcc4',
      component: TMPCC4,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmacf',
      component: TMACF,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmacc1',
      component: TMACC1,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmacc2',
      component: TMACC2,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmacc3',
      component: TMACC3,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmacc4',
      component: TMACC4,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmanb',
      component: TMAnB,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmanc',
      component: TMAnC,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmand',
      component: TMAnD,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmane',
      component: TMAnE,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmanf',
      component: TMAnF,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmang',
      component: TMAnG,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmanh',
      component: TMAnH,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmani',
      component: TMAnI,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmanj',
      component: TMAnJ,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmanhinfo',
      component: TMAnHInfo,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmaniinfo',
      component: TMAnIInfo,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmanjinfo',
      component: TMAnJInfo,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmank',
      component: TMAnK,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmanl',
      component: TMAnL,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmacana',
      component: TMACAnA,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmacana/:_ID',
      name: 'dpstmacadetail',
      component: TMACAnADetail,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM PC Annex A',
      },
      props: true,
      beforeEnter: (to, from, next) => {
        if (to.params._ID == null) {
          next('/404');
        } else {
          next();
        }
      },
    },
    {
      path: '/tmacanb',
      component: TMACAnB,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmbtana1',
      component: TMBTAnA1,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/tmbtana2',
      component: TMBTAnA2,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
    },
    {
      path: '/soon',
      component: ComingSoon,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/tm/:_ID',
      name: 'dpstmdetail',
      component: DPSTmDetail,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TM',
      },
      props: true,
      beforeEnter: (to, from, next) => {
        if (to.params._ID == null) {
          next('/404');
        } else {
          next();
        }
      },
    },
    {
      path: '/tpconc',
      component: TpcOnc,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/tpconcanb',
      component: TPCONCAnB,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/tpconcanc',
      component: TPCONCAnC,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/tpconcand',
      component: TPCONCAnD,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/tpconcane',
      component: TPCONCAnE,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/tpconcanf',
      component: TPCONCAnF,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/tpconcang',
      component: TPCONCAnG,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/tpconcanh',
      component: TPCONCAnH,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/tpconcani',
      component: TPCONCAnI,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/tpconcanj',
      component: TPCONCAnJ,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/tpconcanhinfo',
      component: TPCONCAnHInfo,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/tpconcaniinfo',
      component: TPCONCAnIInfo,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/tpconcanjinfo',
      component: TPCONCAnJInfo,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/tpconcank',
      component: TPCONCAnK,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/tpconcanl',
      component: TPCONCAnL,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/tpconcacana',
      component: TPCONCACAnA,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/tpconcacanb',
      component: TPCONCACAnB,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/tpconcbtana1',
      component: TPCONCBTAnA1,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/tpconcbtana2',
      component: TPCONCBTAnA2,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
    },
    {
      path: '/tpconc/:_ID',
      name: 'dpstpcdetail',
      component: DPSTpcDetail,
      meta: {
        requiresAuth: false,
        title: 'Foundation GEOINT Standards - DPS TPC-ONC',
      },
      props: true,
      beforeEnter: (to, from, next) => {
        if (to.params._ID == null) {
          next('/404');
        } else {
          next();
        }
      },
    },
    {
      path: '/protected-resource',
      component: ProtectedResource,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/404',
      component: NotFound,
    },
    //causing issues with gsx redirect , so disabled for now
    // {
    //   path: '*',
    //   redirect: '/404'
    // }
  ],
});
router.beforeEach(async(to, from, next) => {
    if (to.matched.some(record => record.meta && record.meta.requiresAuth)) {
        if (await AuthService.getValidAuthToken()) {
          next()
        } else {
          try {
            await AuthService.authLogOut()
          } finally {
            next({ path: '/outage' })
          }
        }
    } else {
      window.document.title = to.meta && to.meta.title ? to.meta.title : 'Foundation GEOINT Standards';
      next()
    }
  })
 
  export default router;
